// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-block {
  position: relative; }
  .image-block .image-block-action-buttons {
    position: absolute;
    bottom: 3px;
    left: 3px;
    display: none; }
    .image-block .image-block-action-buttons button, .image-block .image-block-action-buttons label {
      margin-right: 5px; }
  .image-block:hover .image-block-action-buttons {
    display: block; }
  .image-block.image-block-link::after {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    background-color: darkblue;
    color: white;
    content: attr(data-url);
    padding: 0px 5px; }
`, "",{"version":3,"sources":["webpack://./src/components/content-editor/ImageBlock.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa,EAAA;IAPjB;MAUM,iBAAiB,EAAA;EAVvB;IAgBM,cAAc,EAAA;EAhBpB;IAqBI,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,OAAO;IACP,0BAA0B;IAC1B,YAAY;IACZ,uBAAuB;IACvB,gBAAgB,EAAA","sourcesContent":[".image-block {\n  position: relative;\n\n  .image-block-action-buttons {\n    position: absolute;\n    bottom: 3px;\n    left: 3px;\n    display: none;\n\n    button, label {\n      margin-right: 5px;\n    }\n  }\n\n  &:hover {\n    .image-block-action-buttons {\n      display: block;\n    }\n  }\n\n  &.image-block-link::after {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    background-color: darkblue;\n    color: white;\n    content: attr(data-url);\n    padding: 0px 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
